import { Navigate, Outlet } from 'react-router-dom'

export default function PublicRoute() {
    const isLoggedin = localStorage.getItem('limitsUser')
    return !isLoggedin ? <Outlet /> : <Navigate to="/" />
}
